import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
@Component({
  selector: 'app-salary-component',
  templateUrl: './salary-component.component.html',
  styleUrls: ['./salary-component.component.css']
})
export class SalaryComponentComponent implements OnInit {
  Submitted:boolean=false;
  SalaryComponentTypeList=[];
  AccountList=[];
  Listsalary=[];

  constructor(private payrollService: HrService, private lookupservice: LookupService, 
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SalaryComponentModel =
    {
      SalaryComponentID: 0,
      SalaryComponentName: '',
      SalaryComponentCode: '',
      DisplayOrder: 0,
      IsActive: true,
      SalaryComponentTypeID: 0,
      AccountGroupID: 0,
      AccountGroupTypeID: 0,
      AccID: 0,
      IsSalary:false,
      IsLocked: false
    };

  GetSalaryComponentType  () {
    this.lookupservice.GetLookupsList('SalaryComponentType', '').subscribe( (data:any)=> {
      this.SalaryComponentTypeList = data.LookupItems;
    });
  };

  
  Clear  () {
    this.SalaryComponentModel.SalaryComponentID = 0;
    this.SalaryComponentModel.SalaryComponentName = '';
    this.SalaryComponentModel.SalaryComponentCode = '';
    this.SalaryComponentModel.IsLocked = false;
    this.SalaryComponentModel.SalaryComponentTypeID = 0;
    this.SalaryComponentModel.AccountGroupID = 0;
    this.SalaryComponentModel.AccountGroupTypeID = 0;
    this.SalaryComponentModel.AccID = 0;
    this.SalaryComponentModel.DisplayOrder = 0;
    this.SalaryComponentModel.IsActive = true;
    this.SalaryComponentModel.IsSalary=false;
    this.Submitted = false;
    this.ComponentAlert = '';
  };

  ValidateFields() {
  return this.SalaryComponentModel.SalaryComponentTypeID == 0;
};


ComponentAlert = '';
CodeValidation  () {
  for (var i = 0; i < this.Listsalary.length; i++) {
    if (this.Listsalary[i].SalaryComponentTypeID != 1 && this.Listsalary[i].SalaryComponentTypeID != 5 && this.Listsalary[i].SalaryComponentTypeID != 8) {
      if (this.Listsalary[i].SalaryComponentTypeID == this.SalaryComponentModel.SalaryComponentTypeID && this.SalaryComponentModel.SalaryComponentID != this.Listsalary[i].SalaryComponentID) {
        this.ComponentAlert = 'Salary Component Type Already Exist.';
        return false;
      }
    }
  }
  return true;
}


SaveSalaryComponent  (valid) {
  this.Submitted = true;
  if (valid && !this.ValidateFields() && this.CodeValidation()) {
    this.spinnerService.show();
    this.payrollService.SaveSalaryComponent(JSON.stringify(this.SalaryComponentModel)).subscribe( (data:any)=> {
      if (data.webResponse.Status && this.SalaryComponentModel.SalaryComponentID==0 ) {
        this.Clear();
      }
      if (data.webResponse.Status) {
        this.GetSalaryComponent();
      }
      this.globalHelper.CheckActionStatus(data);
    
    });
  }
};

GetStatus  (IsActive) {
  return IsActive ? 'Yes' : 'No';
};

GetSalaryComponent  () {
  this.spinnerService.show();
  this.payrollService.GetSalaryComponent().subscribe( (data:any)=> {
    this.Listsalary = data.Listsalary;
    this.spinnerService.hide();

  });
};

Edit  (obj) {
  this.SalaryComponentModel.SalaryComponentID = obj.SalaryComponentID;
  this.SalaryComponentModel.SalaryComponentName = obj.SalaryComponentName;
  this.SalaryComponentModel.SalaryComponentCode = obj.SalaryComponentCode;
  this.SalaryComponentModel.IsLocked = obj.IsLocked;
  this.SalaryComponentModel.SalaryComponentTypeID = obj.SalaryComponentTypeID.toString().trim();
  this.SalaryComponentModel.DisplayOrder = obj.DisplayOrder;
  this.SalaryComponentModel.IsActive = obj.IsActive;
  this.SalaryComponentModel.IsSalary = obj.IsSalary;
  this.SalaryComponentModel.AccountGroupID = obj.AccountGroupID;
  this.SalaryComponentModel.AccountGroupTypeID = obj.AccountGroupTypeID;
  this.SalaryComponentModel.AccID = obj.AccID;
};

SalaryComponentMarkActive(item) {
    
  this.SalaryComponentModel.SalaryComponentID = item.SalaryComponentID;
  this.SalaryComponentModel.IsActive = item.IsActive == true ? false : true;
  this.payrollService.SalaryComponentMarkActive(JSON.stringify(this.SalaryComponentModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
      this.GetSalaryComponent();
    }
    this.globalHelper.CheckActionStatus(data);
  });

};

ngOnInit() {
  this.GetSalaryComponentType();
  this.GetSalaryComponent();
}

}
